/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
// import bnChartDataService from './chartData.service';
// import { getBoundBoxObj } from './mos/getBoundBoxObj';
// import { getMapMosNum } from './mos/getMapMosNum';
import { processMosRecords } from './mos/processMosRecords';
import AppConst from '../constants/app.constant';
import ApiConstant from '../constants/api.constant';
import httpService from './http.service';
import { getServiceHostPreference } from './utils/getServiceHostPreference';

const mosDataService = () => {
  const content = {};
  let mapMosIcaoIds;
  let mapMosIcaoIdsMap = {};
  let mapMosAirports = [];
  let mapMosDataObj;
  let mosDataLoadedAt;
  let allPoints = [];

  function isMosDataValid() {
    // This function resets MOS data if it is older than mosRequestAge
    const currentTime = window.performance.now();
    if ((currentTime - mosDataLoadedAt) >= AppConst.mosRequestAge) {
      mapMosIcaoIds = null;
      mapMosIcaoIdsMap = {};
      mapMosAirports = [];
      mosDataLoadedAt = null;
      mapMosDataObj = null;
      allPoints = [];
    }
  }

  const cleanAllMos = (data) => data.filter(
    (airport) => airport.icao_id && (airport.lamp || airport.mos),
  );

  content.getMosDataRemote = async () => {
    // const boundObj = getBoundBoxObj(boundingBox, scale);
    const responseData = await httpService.http_get(
      `${getServiceHostPreference()}${ApiConstant.allMosApi}?bncachebuster=${Date.now()}`,
    );
    if (responseData && responseData.length) {
      const mapMosData = cleanAllMos(responseData);
      const processedData = processMosRecords(mapMosData);
      if (processedData) {
        mapMosAirports = processedData.mapMosAirports;
        mapMosIcaoIds = processedData.mapMosIcaoIds;
        mapMosIcaoIdsMap = processedData.mapMosIcaoIdsMap;
        mapMosDataObj = processedData.mapMosDataObj;
        allPoints = processedData.allPoints;
      }
    }
  };
  content.getMosDataModel = () => ({
    mapMosIcaoIds,
    mapMosIcaoIdsMap,
    mapMosDataObj,
    mapMosAirports,
    allPoints,
  });
  content.getData = async (boundingBox, scale) => {
    if (mapMosAirports.length) {
      isMosDataValid();
    }
    if (!mapMosAirports.length) {
      await content.getMosDataRemote(boundingBox, scale);
    }
    return content.getMosDataModel();
  };
  return content;
};
export default mosDataService();
